import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { clearSpaceContentCountsAction } from '~src/spacesPlatform/actions/ContentCountsActions';
import { showContentTypes } from '~src/spacesPlatform/actions/ContentExplorerFilterActions';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import {
  selectCurrentlyApplicableContentTypes,
  selectDefaultContentTypeFilterValues,
} from '~src/spacesPlatform/selectors/ContentFilterSelectors';

import {
  RecycleBinSpace,
  RecyclebinSpaceDispatchProps,
  RecyclebinSpaceOwnProps,
  RecyclebinSpaceStateProps,
} from './RecycleBinSpace';

const mapStateToProps: MapStateToProps<RecyclebinSpaceStateProps> = (state: AppState) => ({
  contentTypeFilterValues: selectCurrentlyApplicableContentTypes(state),
  defaultContentTypeFilterValues: selectDefaultContentTypeFilterValues(state),
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<RecyclebinSpaceDispatchProps> = (dispatch) => bindActionCreators({
  filterSelected: showContentTypes,
  requestSpaceContents,
  clearContentCounts: clearSpaceContentCountsAction
}, dispatch);

export const ConnectedRecycleBinSpace: React.ComponentClass<RecyclebinSpaceOwnProps> =
  connect(mapStateToProps, mapDispatchToProps)(RecycleBinSpace);
